/*
A small helper for building DOM without HTML strings. Wording in the tree is other people's text (names, chats,
questions), so it only ever goes into the page as text: strings passed as children become text nodes, never markup.
*/
type Child = Node | string | null | undefined | false;

export function h(tag: string, attributes: Record<string, string | boolean | null | undefined> = {}, ...children: Child[]): HTMLElement {
  const element = document.createElement(tag);
  for (const [name, value] of Object.entries(attributes)) {
    if (value === null || value === undefined || value === false) continue;
    element.setAttribute(name, value === true ? "" : value);
  }
  for (const child of children) {
    if (child === null || child === undefined || child === false) continue;
    element.append(child);
  }
  return element;
}

export function byId(id: string): HTMLElement | null {
  return document.getElementById(id);
}
